import React, { useState } from 'react';
import { CustomDropZone, DropZoneHelperText, Grid } from 'web-library';
import { useGetNonNationalResultsFileConfig } from '../../../../../api-refactored/non-national-results/useGetNonNationalResultsFileConfig';
import AttachedFiles from '../../../../../components/upload-documents/AttachedFiles';
import { convertMB2Byte } from '../../../../../utils/FileUtils';
import { ComponentFileProcessingState } from './model';

interface IDocumentUploader {
  classes: any;
  translation: any;
  stateHandler: {
    setUploadedFileHandler: {
      uploadedFiles: File[];
      setUploadedFiles: React.Dispatch<React.SetStateAction<File[] | []>>;
    };
    setFileProcessingStatusHandler: {
      fileProcessingStatus?: ComponentFileProcessingState;
      setFileProcessingStatus: React.Dispatch<
        React.SetStateAction<ComponentFileProcessingState | undefined>
      >;
    };
  };
}

const DocumentUploader = ({ classes, translation: t, stateHandler }: IDocumentUploader) => {
  const { uploadedFiles, setUploadedFiles } = stateHandler.setUploadedFileHandler;

  const [dropzoneKey, setDropzoneKey] = useState<string>('');

  const { data: fileConfig } = useGetNonNationalResultsFileConfig({});
  const { fileNumLimit, fileSizeLimit, uploadFileTypes } = fileConfig || {};

  const onFileDelete = () => {
    setUploadedFiles([]);
    setDropzoneKey(Date.now().toString());
  };

  if (!fileConfig) {
    return <></>;
  }

  return (
    <>
      <Grid xs={12} sm={12} md={12} lg={12}>
        <CustomDropZone
          filesLimit={fileNumLimit as any}
          acceptedFiles={uploadFileTypes}
          maxSize={convertMB2Byte(fileSizeLimit || 0)}
          className={classes.dropZone}
          key={dropzoneKey}
          initialFiles={uploadedFiles}
          onChange={setUploadedFiles}
          onDelete={onFileDelete}
        />
      </Grid>
      <DropZoneHelperText
        acceptedFileTypes={uploadFileTypes || []}
        fileLimit={fileNumLimit || 0}
        fileSizeLimit={fileSizeLimit || 1}
      />
      <Grid xs={12} sm={12} md={12} lg={10}>
        <AttachedFiles
          files={uploadedFiles.map((file) => ({
            file,
            hasError: false,
            pending: false,
            uploaded: false,
          }))}
          onUploadFileDelete={() => onFileDelete()}
          setFiles={(files: any) => setUploadedFiles(files.map((f: any) => f.file))}
        />
      </Grid>
    </>
  );
};

export default DocumentUploader;
